// extracted by mini-css-extract-plugin
module.exports = {"office__city":"Office_office__city__3lTRS","office__location":"Office_office__location__1l8O3","office__address":"Office_office__address__1JlZc"};